import merge from 'lodash/merge'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	/* .... Dyn properties from API side mostly .... */
	__updatedAt: new Date().valueOf(),
}

/* Store overall app settings mostly provided by api */
const settingsSlice = createSlice({
	name: 'settings',
	initialState,
	reducers: {
		setSettings(state, { payload }) {
			return merge({}, state, payload)
		},
	},
})

export const { setSettings } = settingsSlice.actions

export default settingsSlice.reducer
